import React from "react";
import { Container, Content } from "./Styled";
import Card from "../../../system/card/Card";
import Title from "../../../system/title/Title";

type BaseChartProps = {
    className?: string;
    children: React.ReactNode;
    title?: string;
};

export const BaseChart: React.FunctionComponent<BaseChartProps> = ({
    className,
    children,
    title
}) => {
    return (
        <Container>
            <Card>
                <Content>
                    {title ? <Title title={title} titleSize="small"></Title> : null}
                    {children}
                </Content>
            </Card>
        </Container>
    );
};

export default BaseChart;
